import axios from 'axios';

import { EnvironmentService } from '@/services/EnvironmentService';

interface ShoperBasketResp {
    continueWithShoperEnabled: boolean;
    shoperBasketUrl?: string;
}

export class ShoperService {
    static async isContinueWithShoperEnabled(): Promise<boolean> {
        try {
            const url = new URL(`${EnvironmentService.getPublicApiURL()}/product/shoper`);
            const { data } = await axios.get<ShoperBasketResp>(url.toString());
            return data.continueWithShoperEnabled;
        } catch (error) {
            return false;
        }
    }
}
